export class MatchGate {
  started = false;

  start(): boolean {
    if (this.started) return false;
    this.started = true;
    return true;
  }

  reset(): void {
    this.started = false;
  }

  canMove(): boolean {
    return this.started;
  }

  shouldLockBrain(historyLength: number): boolean {
    return historyLength > 1;
  }
}
